import React, { useContext, useMemo } from "react";
import ConfigurationContext from "../../../infrastructure/context/configuration/configuration.context";
import UserContext from "../../../infrastructure/context/user/user.context";
import TranslationManager from "../../../infrastructure/translation-manager";
import TranslationsContext from "../../../infrastructure/context/translations/translations-context";
import { TranslationKeys } from "../../../infrastructure/const";

type Props = {
  isVisible: boolean;
  handleCheckoutClick: () => void;
};

const StickyBanner: React.FC<Props> = ({ handleCheckoutClick }) => {
  const configurationContext = useContext(ConfigurationContext);
  const userContext = useContext(UserContext);
  const translationsContext = useContext(TranslationsContext);

  const hidePricesAndPayment = useMemo(
    () =>
      configurationContext &&
      configurationContext.getFeatureFlagValue("hidePricesAndPayment"),
    [configurationContext]
  );

  if (!configurationContext || !userContext) {
    return null;
  }

  const translationManager = new TranslationManager(translationsContext);

  return (
    <div className="cart-stickybanner">
      {hidePricesAndPayment! && (
        <div className="cart-stickybanner__wrapper">
          <div>
            <strong>
              {translationManager.getTranslation(TranslationKeys.TOTAL)}
            </strong>
          </div>
          <div>
            <strong>
              <span className="price">{userContext.cart.displayPrice}</span>
            </strong>
          </div>
        </div>
      )}
      <button
        type="button"
        className="button-addToCart buy-button"
        title="Go to checkout"
        onClick={handleCheckoutClick}
      >
        {translationManager.getTranslation(TranslationKeys.CART_GOTOCHECKOUT)}
      </button>
    </div>
  );
};

export default StickyBanner;
